import Vue from 'vue'
import * as types from '../mutation-types'
import organisations from "../../api/organisations";

var orgTemplate = {
    name: "",
    createdAt: "2000-01-01T00:00:00+00:00",
    updatedAt: "2018-08-12T03:53:37+00:00",
};

// state
export const state = {
    data: orgTemplate,
    users: [],
}


// getters
export const getters = {
    org: state => state.data,
    orgUsers: state => state.users,
}

// mutations
export const mutations = {
    [types.SET_ORG_DETAIL](state, {data, users}) {
        state.data = data;
        state.users = users;
    },
}

// actions
export const actions = {
    getOrgDetail ({ commit }, orgId) {
        organisations.getOrgDetail(orgId, (org, users) => {
            commit(types.SET_ORG_DETAIL, {data: org, users: users})
        })
    },

    updateOrg({commit}, payload) {
        commit(types.SET_ORG_DETAIL, payload)
    },

    revokeAccess({commit}, payload) {
        organisations.revokeAccess(payload, (org, users) => {
            commit(types.SET_ORG_DETAIL, {data: org, users: users})
        })
    },

    updateAccess({commit}, {id, level}) {
        organisations.updateAccess(id, level, (org, users) => {
            commit(types.SET_ORG_DETAIL, {data: org, users: users})
        })
    },

    addAccess({commit}, {entityId, userId, level}) {
        organisations.grantAccess(entityId, userId, level, (org, users) => {
            commit(types.SET_ORG_DETAIL, {data: org, users: users})
        })
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/organisation.js